const SIZE = {
  sm: 'size-8 text-sm',
  md: 'size-9 text-xs',
  lg: 'size-14 text-lg',
} as const;

function initials(name: string) {
  return name
    .split(/\s+/)
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export function Avatar({
  name,
  pictureUrl,
  size = 'md',
  className = '',
}: {
  name: string;
  pictureUrl?: string | null;
  size?: keyof typeof SIZE;
  className?: string;
}) {
  const cls = `${SIZE[size]} rounded-lg shrink-0 ${className}`;

  if (pictureUrl) {
    return (
      <img
        src={pictureUrl}
        alt={name}
        referrerPolicy="no-referrer"
        className={`${cls} object-cover`}
      />
    );
  }

  return (
    <div
      className={`${cls} flex items-center justify-center bg-brand-500 text-white font-semibold`}
    >
      {initials(name) || '?'}
    </div>
  );
}
